import styled, { css } from 'styled-components'

import { SPACING as constants } from '../../../../constants'

import Typography from '../../../../lib/typography'

// prettier-ignore
/** @param {{ nested?: number }} props */
const nestedStyles = props => props.nested && css`
  background-color: #ffffff;

  ${Typography.Data} {
    color: #828282;
  }
`

const columnGrid = css`
  padding: 0 ${constants.GAP};
  display: grid;
  align-items: center;
`

/**
 * @param {ReturnType<typeof css>} moreStyles
 */
export const createTableCard = moreStyles => ({
  Root: styled.div`
    width: 100%;
    border: 1px solid #d4d4d4;
  `,
  Heading: styled.div`
    height: 30px;
    background-color: #404040;
    
    ${columnGrid}
    ${moreStyles}

    ${Typography.Data} {
      color: #ffffff;
    }
  `,
  Container: styled.div`
    height: 39px;
    border-bottom: 1px solid #e6e6e6;
    background-color: #f1f1f1;

    ${columnGrid}
    ${nestedStyles}
    ${moreStyles}
  `,
})
// background-color: #cccccc;
export default createTableCard(css``)



// WEBPACK FOOTER //
// ./src/components/project-information/table/table-submit-project/index.jsx